import { Component, OnInit, OnDestroy, NgZone, EventEmitter, ViewChild, Input } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap/modal';

import { Subscription } from 'rxjs';

import {
    ModelService,
    EquipmentService,
    DataArray,
    Model,
    ToastrService
} from './../../../../shared/index';

@Component({
    selector: 'model-list',
    templateUrl: './model-list.html',
    standalone: false
})

export class ModelListComponent implements OnInit, OnDestroy {
    @ViewChild('equipmentAdd') equipmentAdd: ModalDirective
    @Input('listOnly') listOnly = false;
    @Input() color = 'panel-success';
    @Input('live') live = true;
    @Input('Is_Project_Selected') Is_Project_Selected = false;
    //@Input("isDocumentPage") isDocumentPage: boolean;
    public bounding: any;
    public models: DataArray<Model> = new DataArray<Model>(1);
    public model: Model = new Model();
    public processing = true;

    private subscriptions: Subscription[] = [];

    constructor(
        private _ngZone: NgZone,
        private _modelService: ModelService,
        private _toastrService: ToastrService,
        private _equipmenService: EquipmentService
    ) {
        this.subscriptions.push(this._modelService.filteredModelsChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.models = new DataArray<Model>(1);
                for (const model of info) {
                    this.models.update(model, true);
                }
                if (this.live) {
                    for (let i = 0; i < this.models.Data.length; i++) {
                        this.models.Data[i].Is_Published = true
                    }
                } else {
                    for (let i = 0; i < this.models.Data.length; i++) {
                        this.models.Data[i].Is_Published = this.models.Data[i].Is_Live;
                    }
                }
                this.processing = false;
            });
        }));

        this.subscriptions.push(this._modelService.beginFilter.subscribe((info: boolean) => {
            this._ngZone.run(() => {
                this.models.init();
            });
        }));
    }

    public addAttribute() {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        this._modelService.showAttributes();
    }

    public addModel() {
        if (Number(localStorage.getItem('Lock')) == 1) {
            this._toastrService.displayToastrMessage('error', localStorage.getItem('Msg'), 'Environment Status!');
            return;
        }
        this.model = new Model();
        this._modelService.manipulate(this.model);
    }

    ngOnInit(): void {
        this.models.init();
        this._modelService.applyFilter('', true, true, this.live, [], [], []);
        this._equipmenService.setLive(this.live)
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
